module.exports = __webpack_public_path__ + "media/img/help_center/Student_Profile_04-45690d1ac35fab26f22ee20bebf9a6b1.jpg";